import { combineReducers, Reducer, AnyAction } from '@reduxjs/toolkit';

import reducerChartsList from './reducer/reducerCharts';

interface ChartsReducers {
	chartsList: Reducer<any, AnyAction>;
}

const ChartsStore = combineReducers<ChartsReducers>({
	chartsList: reducerChartsList,
});

export default ChartsStore;